import { Locale, type LocalizedString } from "../Locale.js";
import { serviceSupportPathMap } from "./serviceSupportPathMap.js";

export function getServiceSupportDetailPath(locale: Locale, urlSlug: string): string {
	return `${serviceSupportPathMap[locale]}/${urlSlug}`;
}

export const integrationPathMap = {
	[Locale.cs]: getServiceSupportDetailPath(Locale.cs, "integrace"),
	[Locale.en]: getServiceSupportDetailPath(Locale.en, "integration"),
} satisfies LocalizedString;

export const serviceLifecyclePathMap = {
	[Locale.cs]: getServiceSupportDetailPath(Locale.cs, "servis"),
	[Locale.en]: getServiceSupportDetailPath(Locale.en, "service"),
} satisfies LocalizedString;
